<div class="{{class}} editable">
	<div class="{{header.class}} header inline-editable" data-attribute="header" data-placeholder="{{t "editor.inspector.properties.header.title"}}">{{{getLocaleTextHTML header}}}</div>
	<ul class="list-unstyled view-children"></ul>
	<div class="{{footer.class}} footer inline-editable" data-attribute="footer" data-placeholder="{{t "editor.inspector.properties.footer.title"}}">{{{getLocaleTextHTML footer}}}</div>
</div>
